import { StatusOption } from '../types';

/**
 * Opciones de estado para cada tipo de documento vinculado a una task
 */
export const STATUS_OPTIONS: Record<string, StatusOption[]> = {
  appraisal: [
    { key: 'PENDING', label: "None selected" },
    { key: 'ORDERED', label: "Appraisal ordered" },
    { key: 'RECEIVED', label: "Appraisal received" },
    { key: 'APPROVED', label: "Appraisal approved" },
  ],
  insurance: [
    { key: 'PENDING', label: "None selected" },
    { key: 'CONTACTED', label: "Insurance agent contacted" },
    { key: 'RECEIVED', label: "Insurance documents received" },
    { key: 'APPROVED', label: "Insurance documents approved" },
  ],
  title: [
    { key: 'PENDING', label: "None selected" },
    { key: 'REQUESTED', label: "Title requested" },
    { key: 'VERIFIED', label: "Title verified" },
    { key: 'CLEARED', label: "Title cleared to close" },
  ],
  closing_docs: [
    { key: 'PENDING', label: "None selected" },
    { key: 'APPROVED', label: "Approved" },
  ]
};

/**
 * Obtiene las opciones de estado para un tipo de documento
 */
export const getStatusOptions = (docKey: string): StatusOption[] => {
  return STATUS_OPTIONS[docKey] || [];
};
